<template>
  <div class="careers-screen">
    <div class="container careers-screen__content">
      <ScreenHeader class="careers-screen__header" data-aos="fade-down">
        <template #subtitle>
          {{ subtitle || CAREERS_SCREEN_DEFAULTS.subtitle }}
        </template>
        <template #title>
          {{ title || CAREERS_SCREEN_DEFAULTS.title }}
        </template>
        <template #text>
          {{ description || CAREERS_SCREEN_DEFAULTS.description }}
        </template>
      </ScreenHeader>
      <JobsCatalog :jobs="jobs" preview/>
    </div>
  </div>
</template>

<script setup lang="ts">
const CAREERS_SCREEN_DEFAULTS = {
  title: "We’re hiring!",
  subtitle: "Join Us",
  description: "The best is yet to come. Great games are made by great teams. Want to be part of one?",
}

const props = defineProps<{
  title?: string;
  subtitle?: string;
  description?: string;
  jobs: {
    name: string;
    employmentType: string;
    location: string;
    department: string;
    id: number;
  }[];
}>();
</script>

<style lang="scss">
.careers-screen {
  padding: 64px 0;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
  }

  &__header {
    max-width: 512px;
  }

  &__positions {
    display: flex;
    flex-direction: column;
    gap: 24px;

    width: 100%;
    max-width: 1080px;
  }
}
</style>